import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { Conjunction } from '../../../../types/constants/query-expression';

export class QueryExpressionForm {
  @IsString()
  @IsNotEmpty()
  property: string;

  @IsString()
  @IsNotEmpty()
  operator: string;

  @IsNotEmpty()
  @IsString()
  value: string;

  @IsOptional()
  @IsString()
  conjunction?: Conjunction;
}
